import { memo, useEffect } from "react";
import OwnerDashboardGeneralOverview from "./OwnerDashboardGeneralOverview";
import OwnerDashboardGeneralPieChart from "./OwnerDashboardGeneralPieChart";
import OwnerDashboardGeneralGraph from "./OwnerDashboardGeneralGraph";
import OwnerDashboardGeneralRank from "./OwnerDashboardGeneralRank";

const OwnerDashboardGeneralPage = memo(({ data, filterValue, loading }) => {
  return (
    <div className="w-full col-center-start gap-4">
      <OwnerDashboardGeneralOverview
        data={data}
        loading={loading}
        filterValue={filterValue}
      />
      <OwnerDashboardGeneralGraph
        data={data}
        loading={loading}
        filterValue={filterValue}
      />
      <OwnerDashboardGeneralPieChart
        data={data}
        filterValue={filterValue}
        loading={loading}
      />
      <OwnerDashboardGeneralRank
        data={data}
        filterValue={filterValue}
        loading={loading}
      />
    </div>
  );
});
export default OwnerDashboardGeneralPage;
